<template lang='pug'>
  v-content
    v-container(fluid)
      v-flex
        v-card
          v-toolbar(color='white')
            v-toolbar-title( style='padding : 10px') {{ title }}
          EditDaftarPeriksa()
</template>

<script>
import EditDaftarPeriksa from "@/components/EditDaftarPeriksa.vue";

export default {
  name: "EditPengembalian",
  components: {
    EditDaftarPeriksa,
  },
  data () {
    return {
      title: 'Penyelesaian Pekerjaan',
    }
  },
  mounted () {
  },
  computed: {

  },
  methods: {
   
    },  
  watch :{
     
      }
};
</script>
